import React, { useState, useEffect } from 'react';

const predefinedReasons = [

    "Everything is Okay",

    "Missing Item(s): Order Screenshot",

    "Missing Item(s): Delivered Screenshot",

    "Missing Item(s): Review / Rating Screenshot",

    "Missing Itern(s): Live Review Screenshot",

    "Missing Item(s): Invoice",

    "Missing Item(s): Live Review Link",

    "Mismatched Details: Of Order ID",

    "Mismatched Details: Of Product ID",

    "Mismatched Detalls: Of Product Amount",

    "Mismatched Details: Of Order Date",

    "Mismatched Details: Of Product",

    "Mismatched Details: Of Order Screenshot",

    "Mismatched Details: Of Review Screenshot and Live Review",

    "Mismatched Details: Of Reviewer Name",

    "Suspicious Activity: In Order Screenshot",

    "Suspicious Activity: In Delivered Screenshot",

    "Suspicious Activity: In the Submitted Review / Rating Screenshot",

    "Suspicious Activity: In the Live Review Screenshot",

    "Suspicious Activity: In Live Review Screenshot(Review not verified)",

    "Suspicious Activity: In Invoice(PDF / Screenshot)",

    "Suspicious Activity: In Order Status(Product returned)",

    "Suspicious Activity: In Order Status(Order canceled)",

    "Suspicious Activity: In Order Status(Order not delivered yet)",

    "Wrong Documents / Details SubmiNid: Order Screenshot",

    "Wrong Documents / Details Submitted: Delivered Screenshot",

    "Wrong Documents / Details Submitted: Review / Rating Screenshot",

    "Wrong Documents / Details Submitted: Live Review Screenshot",

    "Wrong Documents / Details Submitted: Invoice",

    "Wrong Documents / Details Submitted: Live Review Link",

    "Wrong Documents / Details Submitted, Live Review Screenshot(Not from logged in account)",

    "Review Quality: Only Rating(No review)",

    "Review Quality: Oniy Rating Required No review needed)",

    "Review Quality Very Short Review",

    "Review Quality: Incorrect Rating",

    "Review Quallty: Review with Title Only(No Description)",

    "Review Quallty: Missing Video",

    "Review Quality: Missing Image",

    "Review Quality: Missing Keywords",

    "Review Quality: Wrong Gender",

    "Screenshot Quality(Resolution) is bad: Order Screenshot",

    "Screenshot Quality(Resolution) is bad: Delivered Screenshot",

    "Screenshot Quality(Resolution) is bad: Review / Rating Screenshot",

    "Screenshot Quality(Resolution) is bad: Live Review Screenshot",

    "Screenshot Quality(Resolution) is bad: Involce",

    "Screenshot Completeness(Not Full Page): Order Screenshot",

    "Screenshot Completeness(Not Full Page): Delivered Screenshot",

    "Screenshot Completeness(Not Full Page): Review / Rating Screenshot",

    "Screenshot Completeness(Not Full Page): Live Review Screenshot",

    "Screenshot Completeness(Not Full Page): Invoice Duplicate",

    "Shipping Fee Issue: Shipping fee exceeds the limit of the standard fee"
];

const RejectModal = ({ isOpen, onClose, onSubmit, selectedReasons, toggleReason, setCustomReason, customReason }) => {
    const [showOthersInput, setShowOthersInput] = useState(false);

    useEffect(() => {
        setShowOthersInput(selectedReasons.includes('Others'));
    }, [selectedReasons]);

    if (!isOpen) return null;

    return (
        <div className="modal is-active">
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-card" style={{ maxWidth: '500px' }}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Reject Participation</p>
                    <button className="delete" aria-label="close" onClick={onClose}></button>
                </header>

                <section className="modal-card-body">
                    <p className="subtitle is-6 mb-2">Select reasons for rejection:</p>
                    {predefinedReasons.map((reason) => (
                        <label key={reason} className="checkbox" style={{ display: 'block', margin: '6px 0' }}>
                            <input
                                type="checkbox"
                                value={reason}
                                checked={selectedReasons.includes(reason)}
                                onChange={() => toggleReason(reason)}
                                style={{ marginRight: "8px" }}
                            />
                            {reason}
                        </label>
                    ))}

                    {showOthersInput && (
                        <div className="field mt-2">
                            <label className="label is-small">Custom Reason</label>
                            <div className="control">
                                <input
                                    type="text"
                                    className="input is-small"
                                    placeholder="Enter your custom reason"
                                    value={customReason}
                                    onChange={(e) => setCustomReason(e.target.value)}
                                />
                            </div>
                        </div>
                    )}

                    <div className="tags mt-3">
                        {selectedReasons
                            .filter((r) => r !== 'Others')
                            .map((reason, index) => (
                                <span key={index} className="tag is-danger is-light mr-2">
                                    {reason}
                                </span>
                            ))}
                        {showOthersInput && customReason && (
                            <span className="tag is-warning is-light">{customReason}</span>
                        )}
                    </div>
                </section>

                <footer className="modal-card-foot">
                    <button className="button is-danger" onClick={onSubmit}>
                        Save & Notify
                    </button>
                    <button className="button" onClick={onClose}>
                        Cancel
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default RejectModal;
